import React from 'react'
import './styles.css'

function LoadingSpinner(props) {
  const {
    color = '#fff',
    size = '80px'
  } = props

  const segments = []
  for (let i = 0; i < 12; i++) {
    segments.push(<div key={i} />)
  }

  return (
    <div data-testid='spinner' styleName='lds-spinner' style={{ color: color, fontSize: size}}>
      { segments }
    </div>
  )
}

export default LoadingSpinner
